export default function(x) {
  return +x;
}



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/d3-scale/src/number.js
// module id = 1284
// module chunks = 0